<div class="outer-container">
    <ng-content></ng-content>
</div>
